(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["volume-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volume-offer')) {
    customElements.define(
      'volume-offer',
      class VolumeOffer extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return
          this.initialized = true

          this.form = this.closest('form')
          this.quantityInput = this.querySelector('[data-offer-quantity-input]')
          this.quantityOutput = this.querySelector('[data-offer-quantity-output]')
          this.singleOption = this.querySelector('[data-offer-option="single"]')
          this.bulkOption = this.querySelector('[data-offer-option="bulk"]')
          this.singleButton = this.querySelector('[data-offer-select="single"]')
          this.bulkButton = this.querySelector('[data-offer-select="bulk"]')
          this.decreaseButton = this.querySelector('[data-offer-decrease]')
          this.increaseButton = this.querySelector('[data-offer-increase]')
          this.variantInput = this.form?.querySelector('input[name="id"]')
          this.minimumQuantity = Number.parseInt(this.dataset.minimumQuantity, 10) || 3
          this.discount = Number.parseInt(this.dataset.discount, 10) || 0
          this.bulkQuantity = this.minimumQuantity
          this.selectedOffer = 'single'
          this.variants = this.parseVariants()
          this.unitPrice = this.getVariantPrice()

          this.singleButton?.addEventListener('click', () => this.selectOffer('single'))
          this.bulkButton?.addEventListener('click', () => this.selectOffer('bulk'))
          this.decreaseButton?.addEventListener('click', () => this.changeBulkQuantity(-1))
          this.increaseButton?.addEventListener('click', () => this.changeBulkQuantity(1))
          this.variantInput?.addEventListener('change', () => this.handleVariantChange())

          this.updatePrices()
          this.syncQuantity(1)
        }

        parseVariants() {
          const variantsJson = this.querySelector('[data-volume-offer-variants]')
          if (!variantsJson) return []

          try {
            return JSON.parse(variantsJson.textContent)
          } catch (error) {
            return []
          }
        }

        getVariantPrice() {
          const variantId = this.variantInput?.value
          const variant = this.variants.find((item) => String(item.id) === String(variantId))
          return Number(variant?.price) || 0
        }

        handleVariantChange() {
          this.unitPrice = this.getVariantPrice()
          this.updatePrices()
        }

        selectOffer(offer) {
          this.selectedOffer = offer
          const isBulk = offer === 'bulk'

          this.singleOption?.classList.toggle('is-selected', !isBulk)
          this.bulkOption?.classList.toggle('is-selected', isBulk)
          this.singleButton?.setAttribute('aria-pressed', String(!isBulk))
          this.bulkButton?.setAttribute('aria-pressed', String(isBulk))
          this.syncQuantity(isBulk ? this.bulkQuantity : 1)
        }

        changeBulkQuantity(change) {
          if (this.selectedOffer !== 'bulk') this.selectOffer('bulk')

          this.bulkQuantity = Math.max(this.minimumQuantity, this.bulkQuantity + change)
          this.syncQuantity(this.bulkQuantity)
          this.updatePrices()
        }

        syncQuantity(quantity) {
          if (this.quantityInput) this.quantityInput.value = quantity
          if (this.quantityOutput) this.quantityOutput.textContent = this.bulkQuantity
          if (this.decreaseButton) this.decreaseButton.disabled = this.bulkQuantity <= this.minimumQuantity

          const formId = this.dataset.productFormId
          if (!formId) return

          document.querySelectorAll(`form[id="${formId}"]`).forEach((form) => {
            if (form === this.form) return

            let syncInput = form.querySelector('[data-volume-offer-sync]')
            if (!syncInput) {
              syncInput = document.createElement('input')
              syncInput.type = 'hidden'
              syncInput.name = 'quantity'
              syncInput.dataset.volumeOfferSync = ''
              form.appendChild(syncInput)
            }
            syncInput.value = quantity
          })
        }

        updatePrices() {
          const multiplier = (100 - this.discount) / 100
          const bulkComparePrice = this.unitPrice * this.bulkQuantity
          const bulkPrice = Math.round(bulkComparePrice * multiplier)
          const discountedUnitPrice = Math.round(this.unitPrice * multiplier)

          this.setMoney('[data-single-price]', this.unitPrice)
          this.setMoney('[data-bulk-price]', bulkPrice)
          this.setMoney('[data-bulk-compare-price]', bulkComparePrice)
          this.setMoney('[data-bulk-unit-price]', discountedUnitPrice)
        }

        setMoney(selector, cents) {
          const element = this.querySelector(selector)
          if (!element) return
          element.innerHTML = this.formatMoney(cents)
        }

        formatMoney(cents) {
          if (typeof window.formatMoney === 'function') return window.formatMoney(cents)

          return new Intl.NumberFormat(this.dataset.locale || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'PLN',
          }).format(cents / 100)
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

})();
